import React from 'react'
import ReactDOM from 'react-dom'
import { App } from './App'
import { Front } from './Front'
import { Auth } from './Auth'

import './styles/index.scss'
import './styles/new.scss'
import './styles/builder.scss'

// Main Account App
const rootDOM = document.getElementById('root')
if (rootDOM) {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    rootDOM,
  )
}

// Front App for main site
const frontDom = document.getElementById('front')
if (frontDom) {
  ReactDOM.render(
    <Front
      levelId={frontDom.dataset.levelId ?? ''}
      sessionId={frontDom.dataset.sessionId ?? ''}
    />,
    frontDom,
  )
}

// Authorization Forms App
const authDOM = document.getElementById('auth')
if (authDOM) {
  ReactDOM.render(<Auth />, authDOM)
}
